export const GUIDE_WELCOME_ADMIN = 160376;
export const GUIDE_WELCOME_NOT_ADMIN = 160731;
export const GUIDE_WORKORDER_CREATE = 160403;
export const GUIDE_WORKORDER_AUTHORIZE = 160478;
export const GUIDE_WORKORDER_CLOSE = 160519;
export const GUIDE_TEF = 156647;
